'use client';

import { useEffect, useState } from 'react';
import { useUnit } from 'effector-react';
import { expandAllParentFoldersEvent } from '@nx-frontend/shared/store/internal-space-menu';
import { setPortalExpandedItemsInListEvent, onPortalFetchedEvent } from '@nx-frontend/shared/store/portal';
import { getWsFirstVisitFx } from '@nx-frontend/shared/store/workspaces';
import { setWsFirstVisitFx } from '@nx-frontend/shared/store/workspaces';
import { MenuType } from '@nx-frontend/shared/types';

interface UseExpandOnFirstLoadProps {
  pathWorkspaceId: string;
  portalId: string;
  userId: number;
}

/**
 * Expands folders and portal on first workspace visit
 * @param param0
 * @returns
 */
export function useExpandOnFirstLoad({ pathWorkspaceId, portalId, userId }: UseExpandOnFirstLoadProps) {
  const [getWsFirstVisit, setWsFirstVisit, expandAllParentFolders, setPortalExpandedItemsInList] = useUnit([
    getWsFirstVisitFx,
    setWsFirstVisitFx,
    expandAllParentFoldersEvent,
    setPortalExpandedItemsInListEvent,
  ]);

  const [isExpandFoldersPortalOnFirstLoad, setIsExpandFoldersPortalOnFirstLoad] = useState(false);

  return useEffect(() => {
    const expandFoldersAndPortal = (portalId: string, workspaceId: string) => {
      // expand folders and portal on first visit workspace
      getWsFirstVisit(workspaceId).then(({ isFirstVisit, wsFirstVisit }) => {
        if (!isFirstVisit) {
          expandAllParentFolders({
            menuType: MenuType.WEBNOTES_MENU,
            id: 'notesFolder#default',
            parentId: 'notesFolder#root',
          });

          if (portalId) {
            setPortalExpandedItemsInList({
              portalId,
              itemIds: ['portal', 'contentAndLinks'],
            });
          }
          setWsFirstVisit({ ...wsFirstVisit, [workspaceId]: true });
        }
      });
    };

    const sub = onPortalFetchedEvent.watch((payload) => {
      // при переходе в другой воркспейс порталы нужно тоже разворачивать
      expandFoldersAndPortal(payload.settings.id, pathWorkspaceId);
    });
    if (!isExpandFoldersPortalOnFirstLoad) {
      expandFoldersAndPortal(portalId, pathWorkspaceId);
      setIsExpandFoldersPortalOnFirstLoad(true);
    }

    return () => {
      sub.unsubscribe();
    };
  }, [
    pathWorkspaceId,
    portalId,
    userId,
    isExpandFoldersPortalOnFirstLoad,
    expandAllParentFolders,
    setPortalExpandedItemsInList,
    getWsFirstVisit,
    setWsFirstVisit,
  ]);
}
